import React, { useEffect, useState } from "react";
import { getVidCloudMgmtUrl, getVidCloudPrivUrl } from "../../services/environment/environmentService";
import { PRE, PRO } from "../../assets/constants";
import axios from "axios";

export const SAML = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const errorParam = params.get("error");

    if (errorParam) {
      setError(errorParam);
      return;
    }

    if (!code) {
      return;
    }

    const { host } = window.location;
    const isPRE = host.includes("pre");
    const env = isPRE ? PRE : PRO;
    sessionStorage.setItem("environment", env);

    const cleanupUrl = window.location.pathname;
    window.history.replaceState(null, "", cleanupUrl);

    const processToken = async (token) => {
      sessionStorage.setItem("oauthTokenB64", token);

      const tokenParts = token.split(".");
      const jsonTokenInfo = atob(tokenParts[1]);
      const tokenInfo = JSON.parse(jsonTokenInfo);
      const userGUID = tokenInfo.sub;

      const vidCloudPrivUrl = getVidCloudPrivUrl(env);
      const appearanceReq = `${vidCloudPrivUrl}/vidmobileuser/${userGUID}/appearance`;
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      const resAppearance = await axios.get(appearanceReq, config);
      sessionStorage.setItem("AccessMethod", "SAML");
      sessionStorage.setItem(
        "appearanceConf",
        btoa(JSON.stringify(resAppearance.data))
      );
      window.location.href = "/documents";
    };

    const fetchToken = async (code) => {
      try {
        const vidCloudManagementUrl = getVidCloudMgmtUrl(env);

        const body = { Code: code };
        const response = await axios.post(`${vidCloudManagementUrl}/saml/token`, body, {
          auth: {
            username: "vidmobileconsoleweb",
            password: "v8h3dp4ks2whs5",
          },
        });
        const { Token: token } = response.data;

        if (!token) {
          throw new Error("Missing token from backend response");
        }

        await processToken(token);
      } catch (err) {
        const message =
          err?.response?.data?.error || err?.message || String(err);
        setError(message);
      }
    };

    fetchToken(code);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        window.location.href = "/";
      }, 3000);
    }
  }, [error]);

  return <>{error && <div>{error}</div>}</>;
};
